export const parsePostsHTML = (html) => {
  const tmp = document.createElement('div');
  tmp.innerHTML = `<table><tbody>${html}</tbody></table>`;

  return tmp.children[0].children[0].children;
};

export const removeDuplicates = () => {
  const allPosts = document.querySelectorAll('body > #Content > table > tbody > tr > td:first-child > a:first-child');

  Array.from(allPosts).forEach((post) => {
    const duplicatePosts = document.querySelectorAll(`body > #Content > table > tbody > tr:first-child > td:first-child > a[href*="${post.url}"]`);

    Array.from(duplicatePosts).slice(1).forEach(duplicatePost => document.removeChild(duplicatePost));
  });
};
